
import React, { useState, useEffect } from "react";
import api from "../Services/api";
import icoDownload from '../../assets/img/ico-download.svg';
import { PulseLoader } from 'halogenium';

const Filtro = (props: any) => {
    const [nextPage, setNextPage] = useState<any[]>([]);
    const [comunicados, setComunicados] = useState<any[]>([]);
    const [notFound, setNotFound] = useState(false);
    const [loading, setLoading] = useState(false);
    const [loadmore, setLoadmore] = useState(false);
    const [error, setError] = useState("");

    useEffect(() => {
        api.get(props.url)
            .then(response => {
                managePagination(response.data.results);
            })
            .catch(error => {
                throw new Error(error);
            });
    }, [props.url]);


    const [form, setForm] = useState({
        planos: "",
        ano: "",
        mes: "",

    });
    const loadMore = () => {
        setLoading(true);
        setLoadmore(true);
        setTimeout(() => {
            setComunicados([...comunicados, ...nextPage.slice(0, 6)]);
            setNextPage(nextPage.slice(6));
            if (nextPage.slice(6).length === 0) {
                setLoadmore(false);
            }
            setLoading(false);

        }, 1000);
    }


    function managePagination(data: any) {
        if (data.length > 6) {
            setComunicados(data.slice(0, 6));
            setNextPage(data.slice(6));
            setLoadmore(true);
        } else {
            setComunicados(data);
        }
    }
    const handleChange = (event: any) => {
        let { name, value } = event.target;
        if (value === "Mês") {
            value = "";
        } if (value === "Ano") {
            value = "";
        }
        setForm({ ...form, [name]: value });
    };

    function handleSubmit(event: any) {
        event.preventDefault();

        setError("");

        if (form.ano === "" && form.mes === "" && form.planos === "") {
            api.get(props.url)
                .then(response => {
                    managePagination(response.data.results);
                })
                .catch(error => {
                    throw new Error(error);
                });

        }
        else if (form.ano === "" || form.mes === "" || form.planos === "") {
            return (setError("* Preencha todos os campos"));;

        }


        else {
            setError("");
            let url = "";
            if (form.ano !== "") {
                url += `&Ano=${form.ano}`;
            }
            if (form.mes !== "") {
                url += `&Mes=${form.mes}`;
            }
            if (form.planos !== "") {
                url += `&Planos=${form.planos}`;
            }
            setComunicados([]);
            setLoading(true);
            api.get(props.urlFiltro + url)
                .then(response => {
                    if (response.data.results.length === 0) {
                        setNotFound(true);
                        setLoading(false);
                    } else {
                        setNotFound(false);
                        managePagination(response.data.results);
                        setLoadmore(true);
                        setLoading(false);
                    }


                })
                .catch(error => {
                    throw new Error(error);

                }
                );
        }
    }

    const years = [];
    for (let i = 2010; i <= new Date().getFullYear(); i++) {
        years.push(i);
    }
    years.reverse();

    function toMonthName(monthNumber: any) {
        if (monthNumber == null) return "NULL";
        const date = new Date();
        date.setMonth(monthNumber - 1);

        return date.toLocaleString('pt-BR', {
            month: 'long',
        });
    }


    return (
        <>
            <div className="_the-content page-comunicados pt-10 mb-8">
                <div className='container d-lg-block'>
                    <div className="row justify-content-center">
                        

                        <div className="col-lg-10 col-xl-9">
                            <h3 className="mb-5"> Filtro </h3>
                            <form className="_form">
                                <div className="row">
                                    <div className="col-12 col-md-4 col-xl-5 mb-3 mb-lg-0">
                                        <span style={{
                                            fontWeight: 'bold',
                                            bottom: '-46%',
                                            left: '-10px',
                                            position: 'relative',
                                            color: 'rgb(232, 116, 0)',
                                        }}>*</span>
                                        <label className="select" htmlFor="o-que-procura">

                                            <select onChange={e => handleChange(e)} id="planos" name="planos">
                                                <option value="">Escolha o Plano</option>
                                                <option value="Plano A">Plano A</option>
                                                <option value="Plano B">Plano B</option>
                                                <option value="Taesa">Taesa</option>
                                                <option value="PGA">PGA</option>
                                                <option value="Consolidado">Consolidado</option>

                                            </select>
                                            <svg width="14" height="8" viewBox="0 0 14 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M7.00072 5.17192L11.9507 0.221924L13.3647 1.63592L7.00072 7.99992L0.636719 1.63592L2.05072 0.221924L7.00072 5.17192Z" fill="#727272" />
                                            </svg>
                                        </label>
                                    </div>
                                    <div className="col-6 col-md-4 col-xl-3 mb-3 mb-lg-0">
                                        <span style={{
                                            fontWeight: 'bold',
                                            bottom: '-46%',
                                            left: '-10px',
                                            position: 'relative',
                                            color: 'rgb(232, 116, 0)',
                                        }}>*</span>
                                        <label className="select" htmlFor="ano">
                                            <select onChange={e => handleChange(e)} id="ano" name="ano">
                                                <option value="" >Ano</option>
                                                {years?.map((year, index) => (
                                                    <option key={index} value={year}>{year}</option>
                                                ))}
                                            </select>
                                            <svg width="14" height="8" viewBox="0 0 14 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M7.00072 5.17192L11.9507 0.221924L13.3647 1.63592L7.00072 7.99992L0.636719 1.63592L2.05072 0.221924L7.00072 5.17192Z" fill="#727272" />
                                            </svg>
                                        </label>
                                    </div>
                                    <div className="col-6 col-md-2">
                                        <span style={{
                                            fontWeight: 'bold',
                                            bottom: '-46%',
                                            left: '-10px',
                                            position: 'relative',
                                            color: 'rgb(232, 116, 0)',
                                        }}>*</span>
                                        <label className="select" htmlFor="mes">

                                            <select onChange={e => handleChange(e)} id="mes" name="mes" >
                                                <option value="" >Mês</option>
                                                <option value="1">Janeiro</option>
                                                <option value="2">Fevereiro</option>
                                                <option value="3">Março</option>
                                                <option value="4">Abril</option>
                                                <option value="5">Maio</option>
                                                <option value="6">Junho</option>
                                                <option value="7">Julho</option>
                                                <option value="8">Agosto</option>
                                                <option value="9">Setembro</option>
                                                <option value="10">Outubro</option>
                                                <option value="11">Novembro</option>
                                                <option value="12">Dezembro</option>

                                            </select>

                                            <svg width="14" height="8" viewBox="0 0 14 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M7.00072 5.17192L11.9507 0.221924L13.3647 1.63592L7.00072 7.99992L0.636719 1.63592L2.05072 0.221924L7.00072 5.17192Z" fill="#727272" />
                                            </svg>
                                        </label>

                                    </div>
                                    <div className="col-12 col-lg-2">
                                        <button onClick={handleSubmit} type="submit" className="btn btn-filter icon rounded" style={{ position: "relative", bottom: "-25px" }}>
                                            <span className="d-lg-none mr-4">
                                                Buscar
                                            </span>
                                            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M7 13C10.3137 13 13 10.3137 13 7C13 3.68629 10.3137 1 7 1C3.68629 1 1 3.68629 1 7C1 10.3137 3.68629 13 7 13Z" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                                <path d="M15 15L12 12" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                            </svg>
                                        </button>
                                    </div>
                                    <span style={{
                                        fontWeight: 'bold',
                                        marginBlockStart: '15px',
                                        position: 'relative',
                                        left: '10px',
                                        color: 'rgb(232, 116, 0)',
                                        bottom: '-24px',
                                    }}>{error}</span>
                                </div>

                            </form>

                            <hr className="mt-8 mb-5" />
                        </div>

                    </div>
                </div>
                <div className='container'>
                    <div className="row justify-content-center">
                        <div className="col-lg-10">
                            <div className="tabs mb-6 pt-8">
                                <div className='row align-items-strech'>

                                    {comunicados?.map((comunicado, index) => (
                                        <div key={index} className="col-md-6 load-post mb-6 ">
                                            <div className="card-comunicado bg-light mb-7">
                                                <div className="card-comunicado__header">
                                                    <p> {comunicado.Descricao} </p>
                                                    <span>Nº {comunicado.Id} - {toMonthName(comunicado.Mes)} de {comunicado.Ano} </span>
                                                </div>

                                                <div className="card-comunicado__title">
                                                    <h4> {comunicado.Title}	</h4>
                                                </div>

                                                <div className="card-comunicado__btn">
                                                    <a rel="noreferrer" href={comunicado.URL} target="_blank" className="btn btn-primary rounded p-0 btn-100">
                                                        <img src={icoDownload} alt="Ícone" />
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                    ))}



                                </div>
                            </div>
                            {notFound === false && loadmore && loading === false && <div style={{ position: "relative" }}> <button id="loadMore" style={{ position: "absolute", left: "50%", top: "45px", msTransform: "translate(-50%, -50%)", transform: "translate(-50%, -50%)" }} className="btn btn-primary py-4 px-5 rounded" onClick={() => loadMore()}>Carregar mais</button></div>}

                            {/* { <button id="loadMore" style={{position:"relative", left:"40%"}} disabled className="btn btn-primary py-4 px-5 rounded" onClick={() => loadMore()}>Carregar mais</button>} */}
                            {loading && <div className="container" id="loading" style={{ position: "relative", left: "35%" }}>
                                <div className="row justify-content-center">
                                    <div className="col-lg-10">
                                        <div className="tabs mb-6 pt-8">
                                            <div className='row align-items-strech'>

                                                <PulseLoader size={20} color="#E87400" margin="4px" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>}
                            {notFound && <div className="container" id="notFound" style={{ position: "relative", left: "1%" }}>
                                <div className="row justify-content-center">
                                    <div className="col-lg-10">
                                        <div className="tabs mb-6 pt-8">
                                            <div className='row align-items-strech'>
                                                <h3>Oops! Não encontramos nada.</h3>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>}

                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};
export default Filtro;